<template>
  <div class="customAlert" v-if="alertText">
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-alert
            icon="mdi-exclamation-thick"
            prominent
            text
            type="info"
            color="red"
          >
            {{ alertText }}
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'CustomAlert',
  props: {
    alertText: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
.customAlert {
  margin-bottom: 15px;

  &::v-deep .v-alert__content,
  a {
    font-size: 12px;
  }

  &::v-deep .v-alert--prominent .v-alert__icon:after {
    top: 7px;
    width: 30px;
    height: 30px;
    left: 8px;
  }

  &::v-deep .v-alert--prominent .v-alert__icon:after {
    top: 7px;
    width: 30px;
    height: 30px;
    left: 8px;
  }

  &::v-deep .v-alert--prominent .v-alert__icon.v-icon {
    font-size: 27px;
  }
}
</style>
